import strings from 'l10n'
import { Alert, Button, Dialog, DialogActions, DialogTitle, DialogContent } from '@mui/material'
type InvoiceSizeWarningProps = {
  errorDialogIsOpen: boolean
  closeErrorDialog: () => void
}

const InvoiceSizeWarning = (props: InvoiceSizeWarningProps) => {
  const { errorDialogIsOpen, closeErrorDialog } = props

  return (
    <>
      <Alert severity="warning" sx={{ marginTop: 2 }}>
        {strings.INFO_MAX_FILE_SIZE}
      </Alert>
      <Dialog open={errorDialogIsOpen} onClose={closeErrorDialog}>
        <DialogTitle>{strings.ERROR_FILE_SIZE_EXCEEDED_TITLE}</DialogTitle>
        <DialogContent>
          <p>{strings.ERROR_FILE_SIZE_EXCEEDED}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeErrorDialog} variant="contained" color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default InvoiceSizeWarning
